export default "__VITE_PUBLIC_ASSET__054353bf__"